import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'fcp-new-banner',
  templateUrl: './new-banner.component.html',
  styleUrls: ['./new-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewBannerComponent implements OnInit {
  @Input() public banner: any;
  @Output() public wasClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasClickedScrollToElement: EventEmitter<
    any
  > = new EventEmitter();

  public isDeviceDesktop: boolean;

  constructor() {
    this.checkDevice();
  }
  
  ngOnInit() {}

  private checkDevice() {
    if (window.innerWidth < 769) {
      this.isDeviceDesktop = false;
      return;
    }
    this.isDeviceDesktop = true;
  }

  public checkClick(button): void {
    button.modal && button.modal.length > 0
      ? this.emitClick(button.modal)
      : this.scrollToElementEmitClick(button.target);
  }

  public emitClick(modal: any): void {
    if (modal) {
      this.wasClicked.emit(modal[0].id);
    }
  }

  public scrollToElementEmitClick(target: string): void {
    if (!Array.isArray(target) && target) {
      this.wasClickedScrollToElement.emit(target);
    }
  }
}
